import React from 'react'
import '../../App.css'
import ProjectSection from '../ProjectSection'
import Cards from '../Cards'

export default function Projects() {
    return(
        <>
            <h1 className='projects'>Projects</h1>
            <Cards/>
        </>

    ) 
}